import React, { useState } from "react"
import classnames from "classnames"
import { MdCheck, MdClose } from "react-icons/md"

//CSS
import componentStyle from "./plan.module.css"
import { navigate } from "gatsby"

const Plan = ({
  name,
  price,
  plan,
  features,
  quoteData,
  index,
  quote,
  cardSelected,
  onSelect,
  noButton = false,
  pdf,
}) => {
  const [firstLoad, setLoad] = useState(true)
  const [selected, selectCard] = useState(cardSelected || false)
  const {
    cardContainer,
    hoveredCard,
    cardHeader,
    hoveredHeader,
    cardBody,
    blueHeader,
  } = componentStyle
  const elemContainer = classnames(
    cardContainer,
    "transition-all",
    "duration-300",
    "linear",
    "transform",
    "hover:shadow-2xl",
    {
      [hoveredCard]:
        (index === 1 &&
          firstLoad &&
          cardSelected &&
          cardSelected.name === name) ||
        (selected && cardSelected && cardSelected.name === name),
    }
  )
  const headerContainer = classnames(
    cardHeader,
    "h-20",
    "py-6",
    "border-b",
    "text-center",
    "font-bold",
    { [hoveredHeader]: selected && cardSelected && cardSelected.name === name },
    { [blueHeader]: cardSelected && cardSelected.name === name }
  )
  const buttonContainer = classnames("text-center", "my-2")

  function onMouseEnter() {
    setLoad(false)
  }

  function _selectCard() {
    selectCard(true)
    return onSelect && typeof onSelect === "function"
      ? onSelect({ name, price, features, plan })
      : false
  }

  const button = quote ? (
    <div className={buttonContainer}>
      <button
        onClick={() => {
          _selectCard()
          navigate("/auth/register", {
            state: { selected: { name, price, plan, features }, quoteData },
          })
        }}
        className="default-button py-3 px-16 mx-auto rounded"
      >
        Seleccionar
      </button>
    </div>
  ) : (
    <div className={buttonContainer}>
      <button
        onClick={() => navigate("/quote")}
        className="default-button py-3 px-20 mb-2 mx-auto rounded"
      >
        Cotizar
      </button>
    </div>
  )

  const mainFeatures = features.filter(f => !f.plus).filter(f => f.type !== "Maximo beneficio")

  // const plusFeatures = features.filter(f => f.plus)

  return (
    <>
      <div
        onClick={_selectCard}
        onMouseEnter={onMouseEnter}
        tabIndex={0}
        className={elemContainer}
        role="row"
        onKeyDown={() => { }}
      >
        <div className={headerContainer}>
          {name}
          {index === 1}
        </div>
        <div className={cardBody}>
          {!quote && (
            <p className="mx-1 text-center mt-2 lg:mx-2 text-md">Desde...</p>
          )}
          {quote && <p className="mt-8"></p>}
          <div className="flex justify-center bg-lightBlue">
            <p className="mt-4 mx-1 lg:mx-1 text-gray-800 text-2xl">$</p>
            <p className="mt-4 font-bold mb-0 text-gray-800 text-4xl">
              {price}
            </p>
            <p className="mt-4 text-center font-medium text-gray-800 text-md">
              /mes
            </p>
          </div>
          <p className="w-10/12 mx-auto mt-3 mb-0 text-center">Máximo beneficio</p>
          <p className="text-center text-gray-800 font-bold mb-3">${features[0].price}</p>
          <div className="mx-16 lg:mx-6 md:mx-0">
            {mainFeatures &&
              mainFeatures.length &&
              mainFeatures.map((elem, i) => {
                return elem && elem.active ? (
                  <div key={i} className="flex text-left">
                    <MdCheck className="mt-1" color="green" />{" "}
                    <p className="text-xs mb-1 ml-1">{elem.type}</p>
                    <p className="text-xs font-bold mb-1">
                      {elem.symbol === "$"
                        ? `: ${elem.symbol}${elem.price}`
                        : `: ${elem.price}${elem.symbol}`}
                    </p>
                  </div>
                ) : (
                  <div key={i} className="flex">
                    <MdClose className="opacity-50 mt-1" />{" "}
                    <p className="text-xs text-gray-500 mb-2 ml-1">
                      {elem.type}
                    </p>
                  </div>
                )
              })}
          </div>
          {!noButton && button}
          <div className="text-center mb-2">
            <a
              href={pdf}
              rel="noopener noreferrer"
              target="_blank"
              className="text-gray-800 text-sm underline cursor-pointer"
            >
              Ver todos detalles del plan
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Plan
